/* eslint-disable camelcase,@typescript-eslint/camelcase */

// Define all the enums and types needed for pit tiles. Also
// define any methods needed to generate and manipulate this data.

import ActionResult from 'app/src/engine/action-results/ActionResult';
import MoveMovableItemActionResult, {
	MoveMovableItemActionResultResult,
} from 'app/src/engine/action-results/MoveMovableItemActionResult';
import Tile from 'app/src/engine/tiles/Tile';

export const tileName = 'PitTile';

export enum PitTileTypeError {
	InvalidType,
}

export enum PitTileType {
	Type1_1of1,
}

export function getPitTileType(name: string): PitTileType {
	switch (name) {
		case 'PitTile-T1-1of1':
			return PitTileType.Type1_1of1;
		default:
			throw PitTileTypeError.InvalidType;
	}
}

export enum PitTileOrientationError {
	InvalidOrientation,
}

export enum PitTileOrientation {
	Up,
	Down,
	Left,
	Right,
}

export function getPitTileOrientation(name: string): PitTileOrientation {
	switch (name) {
		case 'Up':
			return PitTileOrientation.Up;
		case 'Right':
			return PitTileOrientation.Right;
		case 'Down':
			return PitTileOrientation.Down;
		case 'Left':
			return PitTileOrientation.Left;
		default:
			throw PitTileOrientationError.InvalidOrientation;
	}
}

export default class PitTile extends Tile {
	get tileName(): string {
		return tileName;
	}

	get type(): PitTileType {
		return this._type;
	}
	get orientation(): PitTileOrientation {
		return this._orientation;
	}

	private _type: PitTileType;
	private _orientation: PitTileOrientation;

	constructor(type: PitTileType, orientation: PitTileOrientation) {
		super();

		// Save params.
		this._type = type;
		this._orientation = orientation;

		this.allowsMultipleMovableItems = true;
	}

	// When a robot is performing a given result while entering this
	// tile, optionally transform it.
	public transformActionResultWhenEntering(actionResult: ActionResult): void {
		if (actionResult instanceof MoveMovableItemActionResult) {
			actionResult.killsItem = true;
			actionResult.removesItemFromGame = true;
			actionResult.movementResult = MoveMovableItemActionResultResult.Fall;
		}
	}

	public isEqualTo(tile: PitTile): boolean {
		return tile.type === this.type && tile.orientation === this.orientation;
	}

	public clone(): PitTile {
		const clone = new PitTile(this.type, this.orientation);
		clone.walls = new Set(this.walls);
		clone.allowsMultipleMovableItems = this.allowsMultipleMovableItems;
		return clone;
	}
}

export function rotatePitTile(tile: PitTile, clockwise: boolean): PitTile {
	let orientation = tile.orientation;

	if (clockwise) {
		switch (orientation) {
			case PitTileOrientation.Up:
				orientation = PitTileOrientation.Right;
				break;
			case PitTileOrientation.Right:
				orientation = PitTileOrientation.Down;
				break;
			case PitTileOrientation.Down:
				orientation = PitTileOrientation.Left;
				break;
			case PitTileOrientation.Left:
				orientation = PitTileOrientation.Up;
				break;
		}
	} else {
		switch (orientation) {
			case PitTileOrientation.Up:
				orientation = PitTileOrientation.Left;
				break;
			case PitTileOrientation.Right:
				orientation = PitTileOrientation.Up;
				break;
			case PitTileOrientation.Down:
				orientation = PitTileOrientation.Right;
				break;
			case PitTileOrientation.Left:
				orientation = PitTileOrientation.Down;
				break;
		}
	}

	return new PitTile(tile.type, orientation);
}
